import { httpPostBuilder } from '@/utils/http/httpBuilderPresets'
import ShipbobAppSettings from '@/appSettings/appSetting'
import IntegrationEnum from '@/enums/modules/integrations'

const registerStore = async (code, store, type) => {
  try {
    var response
    if (!Object.values(IntegrationEnum).includes(type)) {
      return response
    }

    if (type === IntegrationEnum.shopify) {
      const storeName = store.replace('.myshopify.com', '')
      window.localStorage.setItem('shopifyStoreName', storeName)
    }

    const result = await httpPostBuilder()
      .withUrl(`${ShipbobAppSettings.photoPrint}/${type}/link?code=${code}&shop=${store}`)
      .send()

    switch (result) {
      case 'success':
        response = undefined
        break
      case 'error':
        response = 'error'
        break
      default:
        if (typeof (result) === 'string') {
          response = result
        } else {
          response = 'error'
        }
        break
    }
    return response
  } catch (e) {
    return 'error'
  }
}

export default {
  registerIntegrationStore: async (type, code, store) => {
    var response
    if (!code || !store) return response

    response = await registerStore(code, store, type)
    return response
  }
}
